const importAll = (r) => {
  const images = [];
  r.keys().forEach((key) => {
    const match = key.match(/\.\/(\d+)\/\1-(\d+)\.png$/);
    if (match) {
      const idProducto = match[1];
      if (!images[idProducto]) {
        images[idProducto] = [];
      }

      let img;
      try {
        img = r(key);
      } catch (err) {
        console.warn(`No se pudo cargar la imagen: ${key}`);
        return;
      }

      const src = img?.default ?? img;
      images[idProducto].push(src);
    }
  });

  Object.keys(images).forEach((id) => {
    images[id].sort((a, b) => {
      const n1 = parseInt(a.match(/-(\d+)\.png$/)?.[1] ?? 0);
      const n2 = parseInt(b.match(/-(\d+)\.png$/)?.[1] ?? 0);
      return n1 - n2;
    });
  });

    return images ;
};

const CatalogoImagenesProductosExtras = importAll(
  require.context('../assets/Imagenes/Productos_Caratulas', true, /\.png$/)
);

export default CatalogoImagenesProductosExtras;
